import { render } from "./CompanyDetailsOpportunitiesTab.vue?vue&type=template&id=24383d9a"
import script from "./CompanyDetailsOpportunitiesTab.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsOpportunitiesTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__